var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-custom bgi-no-repeat gutter-b stash-card-1"},[_c('div',{staticClass:"card-body"},[_c('p',{staticClass:"font-size-lg font-weight-bolder mt-5 infoText",domProps:{"innerHTML":_vm._s(_vm.$t('detail.stash.allFileInfo'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }